<template>

    <div class='product-general-info-block configurator-wrapper'>
        <div v-if="data.headline != ''" class="configurator-wrapper__heading">
            {{ data.headline }}
        </div>

        <div class="configurator-wrapper__filter">

            <div class="filter-item" :class="{ 'filter-item__highlighted': ['Gift', 'Offer'].includes(status.filters[filterIndex].name), 'show-block-setting': status.filters[filterIndex].show_block_setting === 'true', 'show-block-product-specific': status.filters[filterIndex].has_products === 'true' }" v-for="(filter, filterIndex) in status.filters" :key="filterIndex" :data-item="status.filters[filterIndex].name">                
                
                <div class="offer-outer-title" v-if="status.filters[filterIndex].name == 'Offer'">
                    {{ filter.outer_title }}
                </div>
                
                <div class="filter-item__heading"
                    :class="{ 'filter-item__heading--disabled': filter.name == 'Optional main mattresses firmness' && !this.selectedOptionalMainmattress }"

                    @click="toggleFilter"
                >
                    <div class="filter-item__heading-block filter-item__heading-block-left">

                        <img :src="filter.thumbnail" width="46" height="46" class="filter-item__heading-image">
                        <div class="filter-item__heading-option-name-and-selected-wrapper">
                            <span class="gift-header" v-if='filter.name == "Gift"'>
                                <svg width="14" height="13" viewBox="0 0 14 13" fill="none">
                                    <path d="M12.5 3.4999H10.3075C10.3319 3.47927 10.3569 3.45927 10.3806 3.4374C10.5704 3.26876 10.7234 3.06276 10.83 2.8323C10.9366 2.60184 10.9944 2.35187 11 2.09802C11.0082 1.82032 10.9596 1.54387 10.8571 1.28564C10.7546 1.02741 10.6004 0.792856 10.404 0.596374C10.2075 0.399893 9.97304 0.245631 9.71484 0.143059C9.45664 0.0404865 9.18021 -0.00823131 8.9025 -0.000103974C8.64855 0.00536593 8.39845 0.0631991 8.16788 0.169775C7.9373 0.276352 7.73121 0.429376 7.5625 0.619271C7.3291 0.889866 7.13932 1.1952 7 1.52427C6.86068 1.1952 6.6709 0.889866 6.4375 0.619271C6.26879 0.429376 6.0627 0.276352 5.83212 0.169775C5.60155 0.0631991 5.35146 0.00536593 5.0975 -0.000103974C4.81979 -0.00823131 4.54336 0.0404865 4.28516 0.143059C4.02696 0.245631 3.79245 0.399893 3.59603 0.596374C3.39961 0.792856 3.24542 1.02741 3.14292 1.28564C3.04043 1.54387 2.99179 1.82032 3 2.09802C3.00556 2.35187 3.06343 2.60184 3.17 2.8323C3.27658 3.06276 3.42956 3.26876 3.61938 3.4374C3.64313 3.45802 3.66813 3.47802 3.6925 3.4999H1.5C1.23478 3.4999 0.98043 3.60525 0.792893 3.79279C0.605357 3.98033 0.5 4.23468 0.5 4.4999V6.4999C0.5 6.76511 0.605357 7.01947 0.792893 7.207C0.98043 7.39454 1.23478 7.4999 1.5 7.4999V11.4999C1.5 11.7651 1.60536 12.0195 1.79289 12.207C1.98043 12.3945 2.23478 12.4999 2.5 12.4999H11.5C11.7652 12.4999 12.0196 12.3945 12.2071 12.207C12.3946 12.0195 12.5 11.7651 12.5 11.4999V7.4999C12.7652 7.4999 13.0196 7.39454 13.2071 7.207C13.3946 7.01947 13.5 6.76511 13.5 6.4999V4.4999C13.5 4.23468 13.3946 3.98033 13.2071 3.79279C13.0196 3.60525 12.7652 3.4999 12.5 3.4999ZM8.3125 1.28177C8.39169 1.19438 8.48808 1.12428 8.59563 1.07589C8.70318 1.02749 8.81957 1.00183 8.9375 1.00052H8.96813C9.10636 1.00138 9.24302 1.02983 9.37012 1.08419C9.49721 1.13855 9.61218 1.21773 9.70828 1.31709C9.80439 1.41645 9.87969 1.534 9.92978 1.66284C9.97987 1.79167 10.0037 1.92921 10 2.0674C9.99869 2.18533 9.97303 2.30171 9.92464 2.40926C9.87624 2.51681 9.80614 2.6132 9.71875 2.6924C9.12562 3.2174 8.14125 3.4024 7.53125 3.4674C7.60625 2.80552 7.8125 1.84365 8.3125 1.28177ZM4.30688 1.30427C4.50059 1.11058 4.76294 1.00119 5.03687 0.999896H5.0675C5.18543 1.00121 5.30182 1.02686 5.40937 1.07526C5.51692 1.13855 5.61331 1.21773 5.6925 1.31709C6.21688 1.87365 6.40188 2.85615 6.46688 3.46365C5.85938 3.40115 4.87687 3.21365 4.28438 2.68927C4.19698 2.61008 4.12689 2.51369 4.07849 2.40614C4.03009 2.29859 4.00443 2.1822 4.00313 2.06427C3.99925 1.92379 4.02395 1.78399 4.07574 1.65335C4.12752 1.52271 4.20531 1.40394 4.30438 1.30427H4.30688ZM1.5 4.4999H6.5V6.4999H1.5V4.4999ZM2.5 7.4999H6.5V11.4999H2.5V7.4999ZM11.5 11.4999H7.5V7.4999H11.5V11.4999ZM12.5 6.4999H7.5V4.4999H12.5V6.4999Z" fill="currentColor"/>
                                </svg>
                                {{ filter.free_gift }}
                            </span>
                            <span class="special-offers-header" v-if='filter.name == "Offer"'>
                                <span>{{ filter.title }}</span>
                                <div>{{ filter.tag_text }}</div>
                            </span>
                            <div class="filter-item__heading-option-name-and-selected" v-if="status.filters[filterIndex].name != 'Offer'">
                                <div class="filter-item__heading-option-name">
                                    {{ filter.title }}
                                </div>
                                <span class="filter-item__heading-option-selected">{{ filter.currentValue.replaceAll(",", ", ")  }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="filter-item__open">
                        <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.23645 0.23645L4.23645 4.23645L8.23645 0.23645" stroke="black" stroke-width="0.472885" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div class="filter-item__content" v-if="status.filters[filterIndex].name == 'Size'">                        
                    <div v-for="(size, index) in status.filters[filterIndex].availableSizes" 
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': size.id === status.productId }"
                        @click="updateSize(size, filterIndex)"
                    >
                        <img :src="size.featured_image?.src || size.featured_image || size.images?.[0]" width="98" height="113"> 
                        <span class="filter-item__title">{{ size.title.split(" | ")[1].trim() }}</span>
                        <span class="filter-item__size"></span>
                        <span class="filter-item__total"></span>                     
                    </div>
                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Color'">                        
                    <div v-for="(color, index) in status.filters[filterIndex].availableColors" 
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': color.name == status.filters[filterIndex].currentValue }"
                        @click="updateColor(color.name, filterIndex)"
                    >
                        <img :src="color.image" width="98" height="113"> 
                        <span class="filter-item__title">{{ color.name }}</span>
                        <span class="filter-item__size">{{ status.currentSize }}</span>
                        <span class="filter-item__total"><span v-if="color.addon_price">+{{ color.addon_price }}</span></span>                     
                    </div>
                </div>

                <div class="filter-item__content filter-item__content--reduced-padding" v-else-if="status.filters[filterIndex].name == 'Side'">
                    <div v-if="status.filters[filterIndex].descriptiveText" class="filter-item__descriptive-text">
                        <span>{{ status.filters[filterIndex].descriptiveText }}</span>
                    </div>                      
                    <div v-for="(side, index) in status.filters[filterIndex].options[0].values" 
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': side.value == status.filters[filterIndex].currentValue }"
                        :data-side-value="side.value"
                        @click="updateSide(side.value, side.variantId, filterIndex, index)"
                    >
                        <img :src="side.image" width="98" height="113"> 
                        <span class="filter-item__title">{{ side.value }}</span>
                        <span class="filter-item__size"></span>
                    </div>
                </div>

                <div class="filter-item__content filter-item__content--reduced-padding" v-else-if="status.filters[filterIndex].name == 'Firmness'">
                    <div v-if="status.filters[filterIndex].descriptiveText" class="filter-item__descriptive-text">
                        <span>{{ status.filters[filterIndex].descriptiveText }}</span>
                    </div>                       
                    <div class="filter-item__firmness-wrapper">
                        <div class="filter-item__firmness-options">
                            <div v-for="(firmness, index) in status.filters[filterIndex].options" 
                                class="firmness-options__column"
                                :class="'firmness-options__column--' + (index + 1)">
                                <div class="firmness-options__column-header">{{ firmness.optionName }}</div>
                                <div v-for="(value, innerIndex) in firmness.values" 
                                    class="filter-item__select"
                                    :class="{ 'filter-item__select--active': value.value == status['option' + (index+1)] }"
                                    :data-option-id="'option' + (index + 1)"
                                    :data-value = "value.value"
                                    :data-filter-index = filterIndex
                                    @click="updateVariant">
                                    {{ value.value }} 
                                    <span v-if="value.priceIncrement != undefined" class="filter-item__select--highlight">+{{ value.priceIncrement }}</span>
                                </div>
                            </div>
                            <div class="firmness-options__column firmness-options__column--spacer"></div>
                        </div>                        

                        <div class="filter-item__firmness-details">
                            <div v-for="(info, index) in status.filters[filterIndex].options[0].values" class="filter-item__firmness-details-item">
                                {{ info.info }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Optional main mattresses'">                        
                    <div v-for="(mattress, index) in status.upsells.find(item => item.productId == status.productId)?.optional_mainmattresses" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': mattress.id == this.selectedOptionalMainmattress }"
                        :data-variant-id = "mattress.id"
                        :data-variant-name = "mattress.name"
                        @click="updateOptionalMainmattress(mattress.id, mattress.name, mattress.description, mattress.thumbnail, filterIndex)"
                    >   
                        <div class="filter-item__icon-container" v-if="mattress.iconBg" :style="{ 'background-color': mattress.iconBg }">
                            <img :src=topmattress.iconImage>
                        </div>

                        <img :src="mattress.thumbnail" width="98" height="113"> 
                        <span class="filter-item__title">{{ mattress.name }}</span> 
                        <span class="filter-item__size">{{ mattress.description }}</span>
                        <span class="filter-item__total" v-if="mattress.price">+{{ mattress.price }}</span>
                    </div>
                </div>
                
                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Optional main mattresses firmness'">
                    <div v-if="selectedOptionalMainmattressOptions" class="filter-item__firmness-wrapper">
                        <div class="filter-item__firmness-options">
                            <div v-for="(firmness, index) in this.selectedOptionalMainmattressOptions" 
                                class="firmness-options__column"
                                :class="'firmness-options__column--' + (index + 1)">
                                <div class="firmness-options__column-header">{{ firmness.name }}</div>
                                <div v-for="(value, innerIndex) in firmness.values" 
                                    class="filter-item__select"
                                    :class="{ 'filter-item__select--active': value == this.selectedOptionalMainmattressOptionsPicked['option' + (index+1)] }"
                                    :data-option-id="'option' + (index + 1)"
                                    :data-value = "value"
                                    :data-filter-index = filterIndex
                                    @click="updateMainMattressFirmness">
                                    {{ value.replace(/\s*\(.*$/, "").trim() }} 
                                    <span v-if="value.includes('+')" class="filter-item__select--highlight">+{{ value.split('+')[1].trim() }}</span>
                                </div>
                            </div>
                            <div class="firmness-options__column firmness-options__column--spacer"></div>
                        </div>                        

                        <div v-if="selectedOptionalMainmattressOptions.length" class="filter-item__firmness-details">
                            <div v-for="(firmness_info, index) in this.selectedOptionalMainmattressOptions[0].values" 
                            class="filter-item__firmness-details-item">
                                {{ firmness_info.match(/\(.*?:\s*(.*?)\)/)?.[1] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Mattresses'">                        
                    <div v-for="(topmattress, index) in status.upsells.find(item => item.productId == status.productId)?.topmattresses" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': topmattress.id == this.selectedTopmattress }"
                        :data-variant-id = "topmattress.id"
                        :data-variant-name = "topmattress.name"
                        @click="updateTopmattress(topmattress.id, topmattress.name, topmattress.description, topmattress.thumbnail, filterIndex)"
                    >   
                        <div class="filter-item__icon-container" v-if="topmattress.iconBg" :style="{ 'background-color': topmattress.iconBg }">
                            <img :src=topmattress.iconImage>
                        </div>

                        <img :src="topmattress.thumbnail" width="98" height="113"> 
                        <span class="filter-item__title">{{ topmattress.name }}</span> 
                        <span class="filter-item__size">{{ topmattress.description }}</span>
                        <span class="filter-item__total" v-if="topmattress.price">+{{ topmattress.price }}</span>             
                    </div>
                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Optional top mattresses'">                        
                    <div v-for="(topmattress, index) in status.upsells.find(item => item.productId == status.productId)?.optional_topmattresses" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': topmattress.id == this.selectedOptionalTopmattress }"
                        :data-variant-id = "topmattress.id"
                        :data-variant-name = "topmattress.name"
                        @click="updateOptionalTopmattress(topmattress.id, topmattress.name, topmattress.description, topmattress.thumbnail, filterIndex)"
                    >   
                        <div class="filter-item__icon-container" v-if="topmattress.iconBg" :style="{ 'background-color': topmattress.iconBg }">
                            <img :src=topmattress.iconImage>
                        </div>

                        <img :src="topmattress.thumbnail" width="98" height="113"> 
                        <span class="filter-item__title">{{ topmattress.name }}</span> 
                        <span class="filter-item__size">{{ topmattress.description }}</span>
                        <span class="filter-item__total" v-if="topmattress.price">+{{ topmattress.price }}</span>             
                    </div>
                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Optional puf'">                        
                    <div v-for="(puf, index) in status.upsells.find(item => item.productId == status.productId)?.optional_puf" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': puf.id == this.selectedOptionalPuf }"
                        :data-variant-id = "puf.id"
                        :data-variant-name = "puf.name"
                        @click="updateOptionalPuf(puf.id, puf.name, puf.description, puf.thumbnail, filterIndex)"
                    >   
                        <img :src="puf.thumbnail" width="98" height="113"> 
                        <span class="filter-item__title">{{ puf.name }}</span> 
                        <span class="filter-item__size">{{ puf.description }}</span>
                        <span class="filter-item__total" v-if="puf.price">+{{ puf.price }}</span>             
                    </div>
                </div>

                <div class="filter-item__content filter-item__content--vertical-layout " v-else-if="status.filters[filterIndex].name == 'Headboards'">                        
                    <div v-for="(headboard, index) in (status.upsells.find(item => item.productId == status.productId)?.headboards || [])" :key="index"
                        class="filter-item__select filter-item__select-card filter-item__select-card--vertical-layout"
                        :class="{ 'filter-item__select--active': headboard.id == this.selectedHeadboard }"
                        :data-variant-id = "headboard.id"
                        :data-variant-name = "headboard.name"
                        @click="updateHeadboard(headboard.id, headboard.name, headboard.thumbnail, headboard.previewImage, filterIndex)"
                    >
                        <div class="filter-item__select-card__content-wrapper">
                            <div class="filter-item__select-card__left-wrapper">
                                <img v-if="index > 0" :src="headboard.thumbnail" width="98" height="113"> 
                                <span class="filter-item__title">{{ headboard.name }}</span>
                            </div>
                            <div class="filter-item__select-card__right-wrapper">
                                <span class="filter-item__total" v-if="headboard.price">+{{ headboard.price }}</span>
                                <span class="filter-item__compare_price" v-if="headboard.compare_at_price">{{ headboard.compare_at_price }}</span>
                            </div>
                        </div>
                        
                        <div v-if="index > 0" class="filter-item__preview-image--vertical-layout">
                            <span>{{ headboard.product_dimensions }}</span>
                            <img v-if="headboard.previewImage" :src=headboard.previewImage>
                        </div>
                    </div>

                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Legs'">                        
                    <div v-for="(leg, index) in (status.upsells.find(item => item.productId == status.productId)?.legs || [])" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': leg.id == this.selectedLegs }"
                        :data-variant-id = "leg.id"
                        :data-variant-name = "leg.name"
                        @click="updateLegs(leg.id, leg.name, leg.thumbnail, leg.previewImage, leg.height, filterIndex)"
                    >
                        <img :src="leg.thumbnail" width="98" height="113"> 
                        <span class="filter-item__title">{{ leg.name }}</span> 
                        <span class="filter-item__size">{{ leg.height }}</span>
                        <span class="filter-item__total" v-if="leg.price">+{{ leg.price }}</span>             
                    </div>

                    <img v-if="this.selectedLegsPreview" :src=this.selectedLegsPreview class="filter-item__preview-image">

                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Sheets'">

                    <div v-for="(sheet, index) in (status.upsells.find(item => item.productId == status.productId)?.sheets || [])" :key="index" class="filter-item__select-card-wrapper">
                        
                        <div class="filter-item__select filter-item__select-card filter-item__select-card-multiselect"
                        :class="{ 'filter-item__select--active': status.filters[filterIndex].currentValueId.includes(sheet.id)}"
                        :data-variant-id = "sheet.id"
                        :data-variant-name = "sheet.color"
                        @click="multiselectToggleSheets">

                            <span v-if="sheet.id !=''" class="filter-item__select-card-radio-wrapper">
                                <span class="filter-item__select-card-radio-circle"></span>
                            </span>

                            <img :src="sheet.thumbnail" width="98" height="113"> 
                            <span class="filter-item__title">{{ sheet.color }}</span>    
                            <span class="filter-item__size">{{ sheet.size }}</span> 
                            <span :data-price="sheet.rawPrice" class="filter-item__total">{{ sheet.price }}</span>

                        </div>

                        <QuantitySelector v-if="sheet.id !=''"
                            :elemId=sheet.id
                            :elemPrice=sheet.rawPrice
                            :elemOriginalPrice=sheet.rawPrice
                            @item-quantity-update = "itemQuantityUpdateSheets"
                        ></QuantitySelector>
                    </div>
                </div>
                
                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Gift' && status.filters[filterIndex].has_products === 'true'">
                    <div v-for="(gift, index) in (status.upsells.find(item => item.productId == status.productId)?.gifts || [])" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': gift.id == this.selectedGift }"
                        :data-variant-id = "gift.id"
                        :data-variant-name = "gift.name"
                        @click="updateGift(gift.id, gift.name, gift.thumbnail, gift.previewImage, gift.size, filterIndex)"
                    >
                        <img :src="gift.thumbnail" width="98" height="113"> 

                        <span class="filter-item__title">{{ gift.name }}</span> 
                        <span class="filter-item__size">{{ gift.size }}</span>
                        <span class="filter-item__total">{{ gift.free }}</span>             
                    </div>
                </div>

                <div class="filter-item__content" v-else-if="status.filters[filterIndex].name == 'Offer'">                       
                    <div 
                    v-for="(offer, index) in (status.upsells.find(item => item.productId == status.productId)?.offers || [])" 
                    :key="index" 
                    class="filter-item__select-card-wrapper"
                    >
                        
                        <div class="filter-item__select filter-item__select-card filter-item__select-card-multiselect"
                        :class="{ 'filter-item__select--active': status.filters[filterIndex].currentValueId.includes(offer.id)}"
                        :data-variant-id = "offer.id"
                        :data-variant-name = "offer.name"
                        @click="multiselectToggleOffers">

                            <span v-if="offer.id !=''" class="filter-item__select-card-radio-wrapper">
                                <span class="filter-item__select-card-radio-circle"></span>
                            </span>

                            <img :src="offer.thumbnail" width="98" height="113"> 
                            <span class="filter-item__title">{{ offer.name }}</span>    
                            <span class="filter-item__size">{{ offer.size }}</span> 
                            <span :data-price="offer.rawPrice" class="filter-item__total">
                                <span class="currentPrice">{{ offer.price }}</span>
                                <span class="basePrice">{{ offer.original_price }}</span>
                            </span>
                            <span class="sale-badge">-{{ offer.discount_percentage }}%</span>
                            <span 
                            class="header-data"
                            :data-header-title="offer.block_title"
                            :data-header-outer-title="offer.block_outer_title"
                            :data-header-tag-text="offer.block_tag_text"
                            :data-header-thumbnail="offer.block_thumbnail"
                            >
                            </span>
                        </div>

                        <QuantitySelector v-if="offer.id !=''"
                            style="display: none;"
                            :elemId=offer.id
                            :elemPrice=offer.rawPrice
                            :elemOriginalPrice=offer.rawOriginalPrice
                            @item-quantity-update = "itemQuantityUpdateOffers"
                        ></QuantitySelector>
                    </div>
                </div>

                <div class="filter-item__content filter-item__content--reduced-padding" v-else-if="status.filters[filterIndex].name == 'Storage alternative'">
                    <div v-if="status.filters[filterIndex].descriptiveText" class="filter-item__descriptive-text">
                        <span>{{ status.filters[filterIndex].descriptiveText }}</span>
                    </div>                     
                    <div v-for="(storage, index) in status.filters[filterIndex].availableStorage" :key="index"
                        class="filter-item__select filter-item__select-card"
                        :class="{ 'filter-item__select--active': (this.status.extraStorage == 1 && index == 1) || (this.status.extraStorage == 0 && index == 0) }"
                        @click="updateStorage(index, filterIndex)"

                    >
                    
                        <img :src="this.storageIcons[index]" width="98" height="113"> 
                        <span class="filter-item__title">{{ storage }}</span>
                        <span class="filter-item__size"></span>
                    </div>

                </div>

                <div class="filter-item__content" v-else>
                    <div v-for="(option, index) in status.filters[filterIndex].options" 
                        class="filter-item__select"
                        :class="{ 'filter-item__select--active': (option.original) == status.filters[filterIndex].currentValue }"
                        :data-option-id="'option' + (filterIndex)"
                        :data-value = "option.value"
                        :data-filter-index = filterIndex
                        @click="updateVariant"
                    >
                        {{ option.value }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

  
  
<script>
import QuantitySelector from './componenets/quantity-selector.vue'
export default {
    emits: [
    ],
    name: 'App',
    components: {
        QuantitySelector
    },
    setup() {
        const data = configurator;
        return {
            data
        }
    },
    data() {
        return {
            status: configurator,
            currentPage: configurator.currentPage,
            selectedSheets: [],
            selectedOffers: [],
            selectedHeadboard: 0,
            selectedHeadboardPreview: "",  
            selectedGift: configurator.upsells[0]?.gifts?.length > 0 ? configurator.upsells[0].gifts[0].id : 0 ,         
            selectedLegs: configurator.upsells[0]?.legs?.length > 0 ? configurator.upsells[0].legs[0].id : 0 ,
            selectedLegsPreview: configurator.upsells[0]?.legs?.length > 0  ? configurator.upsells[0].legs[0].previewImage: "",
            selectedTopmattress: configurator.upsells[0]?.topmattresses?.length > 0 ? configurator.upsells[0].topmattresses[0].id : 0,
            selectedOptionalTopmattress: configurator.upsells[0]?.optional_topmattresses?.length > 0 ? configurator.upsells[0].optional_topmattresses[0].id : 0,
            selectedOptionalMainmattress: configurator.upsells[0]?.optional_mainmattresses?.length > 0 ? configurator.upsells[0].optional_mainmattresses[0].id : 0,
            selectedOptionalPuf: configurator.upsells[0]?.optional_puf?.length > 0 ? configurator.upsells[0].optional_puf[0].id : 0,
            selectedOptionalMainmattressOptions: [],
            selectedOptionalMainmattressOptionsPicked: {},
            selectedOptionalMainmattressVariant: 0,
            selectedOptionalMainmattressVariantPrice: 0,
            sideFilterIndex: configurator.filters.findIndex(filter => filter.name === 'Side'),
            selectedSide: 0,
            selectedVariantImg: 0,
            extraCart: [],
            storageIcons: []
        }
    },
    mounted() {
        document.querySelector('.product__info-wrapper').classList.add('configurator-mounted');
        //set minimum height to reduce content jumping
        const mainWrapper = document.querySelector('.configurator-wrapper');
        const mainHeight = mainWrapper.offsetHeight;
        mainWrapper.style.minHeight = mainHeight + "px";

        //event listener for building payload of extra items
        const app = this;
        document.addEventListener("click", function(e){
            const target = e.target.closest(".product-form__btn-wrapper button");
            let quantity = document.querySelector('.quantity__input').value;            

            if(target){
                app.buildPayload(quantity);
            }
        });

        this.setStorageThumbnails();
        
    },
    methods: {
        selectMatchingVariant() {
            const list = Array.isArray(this.status.connectedProducts) ? this.status.connectedProducts : [];
            const baseProduct = list.find(p => p.id == this.status.productId) || this.status.baseProduct;

            if (!baseProduct || !baseProduct.variants) return;

            const targetVariant = baseProduct.variants.find(obj => {
                // If options 1 and 2 are set, match both
                if (this.status.option1 && this.status.option2) {
                    return obj.option1.startsWith(this.status.option1) && obj.option2.startsWith(this.status.option2);
                }
                // If only option 1 is set, match just that
                if (this.status.option1) {
                    return obj.option1.startsWith(this.status.option1);
                }
                // Fallback if no firmness options are configured/set
                return false;
            });

            if (targetVariant) {
                this.status.currentVariant = targetVariant.id;
                // Crucially, update the URL (which holds the current variant)
                const newUrl = this.currentPage.split('?variant=')[0] + "?variant=" + this.status.currentVariant;
                if (newUrl !== this.currentPage) {
                    this.currentPage = newUrl;
                    window.history.replaceState(null, document.title, this.currentPage);
                }
            } else if (baseProduct.variants?.[0]?.id) {
                // Fallback to the first variant if no match is found, ensuring it's never undefined
                this.status.currentVariant = baseProduct.variants[0].id;
            }
        },
        toggleFilter(event) {
            
            //close other filters
            document.querySelectorAll('.filter-item').forEach( item => {
                if (item != event.target.parentNode) {
                    item.classList.remove('filter-item--active');
                }
            })

            // toggle clicked filter
            event.target.parentNode.classList.toggle('filter-item--active');
            event.stopPropagation();
        },
        remapSelectionsToCurrentProduct() {
            const currentId = this.status.productId;
            const currentUpsells = (this.status.upsells || []).find(u => u.productId === currentId) || {};

            // Headboard: map by current filter value (name). If missing, default first paid item (index > 0) else 0.
            const headboardFilter = this.status.filters.find(f => f.name === 'Headboards');
            if (headboardFilter && Array.isArray(currentUpsells.headboards)) {
                const byName = currentUpsells.headboards.find(h => h.name === headboardFilter.currentValue);
                const fallback = currentUpsells.headboards[1] || currentUpsells.headboards[0] || null;
                const chosen = byName || fallback;
                this.selectedHeadboard = chosen ? chosen.id : 0;
                this.selectedHeadboardPreview = chosen?.previewImage || '';
                if (chosen) {
                    headboardFilter.currentValue = chosen.name;
                    headboardFilter.thumbnail = chosen.thumbnail || headboardFilter.thumbnail;
                }
            }

            // Top mattress: keep same id if exists; else first available
            if (Array.isArray(currentUpsells.topmattresses)) {
                const keep = currentUpsells.topmattresses.find(t => t.id == this.selectedTopmattress);
                const fallback = currentUpsells.topmattresses[0];
                const chosen = (keep || fallback) || null;
                this.selectedTopmattress = chosen?.id || 0;
                const topFilterIndex = this.status.filters.findIndex(i => i.name === 'Mattresses');
                if (topFilterIndex !== -1 && chosen) {
                    this.status.filters[topFilterIndex].currentValue = chosen.description ? `${chosen.name} (${chosen.description})` : chosen.name;
                    this.status.filters[topFilterIndex].thumbnail = chosen.thumbnail || this.status.filters[topFilterIndex].thumbnail;
                }
            }

            // Optional top mattress: keep or first
            if (Array.isArray(currentUpsells.optional_topmattresses)) {
                const keep = currentUpsells.optional_topmattresses.find(t => t.id == this.selectedOptionalTopmattress);
                const fallback = currentUpsells.optional_topmattresses[0];
                const chosen = (keep || fallback) || null;
                this.selectedOptionalTopmattress = chosen?.id || 0;
                const optFilterIndex = this.status.filters.findIndex(i => i.name === 'Optional top mattresses');
                if (optFilterIndex !== -1 && chosen) {
                    this.status.filters[optFilterIndex].currentValue = chosen.description ? `${chosen.name} (${chosen.description})` : chosen.name;
                    this.status.filters[optFilterIndex].thumbnail = chosen.thumbnail || this.status.filters[optFilterIndex].thumbnail;
                }
            }

            // Optional main mattress + firmness mapping
            if (Array.isArray(currentUpsells.optional_mainmattresses)) {
                const keep = currentUpsells.optional_mainmattresses.find(m => m.id == this.selectedOptionalMainmattress);
                const fallback = currentUpsells.optional_mainmattresses[0];
                const chosen = keep || fallback;
                this.selectedOptionalMainmattress = chosen ? chosen.id : 0;
                // Rebuild firmness options and variant
                if (chosen) {
                    const opts = Array.isArray(chosen.options) ? chosen.options[0] : undefined;
                    this.selectedOptionalMainmattressOptions = opts || [];
                    // Preserve picked options where possible
                    const o1 = this.selectedOptionalMainmattressOptionsPicked.option1;
                    const o2 = this.selectedOptionalMainmattressOptionsPicked.option2;
                    const firstO1 = this.selectedOptionalMainmattressOptions[0]?.values?.[0];
                    const firstO2 = this.selectedOptionalMainmattressOptions[1]?.values?.[0];
                    this.selectedOptionalMainmattressOptionsPicked.option1 = o1 && this.selectedOptionalMainmattressOptions[0]?.values?.includes(o1) ? o1 : firstO1;
                    this.selectedOptionalMainmattressOptionsPicked.option2 = this.selectedOptionalMainmattressOptions[1]?.values ? (this.selectedOptionalMainmattressOptions[1].values.includes(o2) ? o2 : firstO2) : undefined;

                    // Resolve variant
                    const variants = Array.isArray(chosen.variants) ? chosen.variants[0] : [];
                    const variant = variants?.find(v => v.option1 == this.selectedOptionalMainmattressOptionsPicked.option1 && (!this.selectedOptionalMainmattressOptions[1] || v.option2 == this.selectedOptionalMainmattressOptionsPicked.option2));
                    this.selectedOptionalMainmattressVariant = variant?.id || 0;
                    this.selectedOptionalMainmattressVariantPrice = Number(variant?.price || chosen.rawPrice || 0);

                    // Reflect currentValue for the firmness filter display
                    const idx = this.status.filters.findIndex(f => f.name === 'Optional main mattresses firmness');
                    if (idx !== -1) {
                        const parts = [this.selectedOptionalMainmattressOptionsPicked.option1, this.selectedOptionalMainmattressOptionsPicked.option2].filter(Boolean);
                        this.status.filters[idx].currentValue = parts.join(', ');
                    }
                }
            }

            // Legs: keep id if exists, update preview; else default first
            if (Array.isArray(currentUpsells.legs)) {
                const keep = currentUpsells.legs.find(l => l.id == this.selectedLegs);
                const fallback = currentUpsells.legs[0];
                const chosen = keep || fallback;
                this.selectedLegs = chosen ? chosen.id : 0;
                this.selectedLegsPreview = chosen?.previewImage || '';
                const legsFilterIndex = this.status.filters.findIndex(i => i.name === 'Legs');
                if (legsFilterIndex !== -1 && chosen) {
                    const height = chosen.height ? ` (${chosen.height})` : '';
                    this.status.filters[legsFilterIndex].currentValue = `${chosen.name}${height}`;
                    this.status.filters[legsFilterIndex].thumbnail = chosen.thumbnail || this.status.filters[legsFilterIndex].thumbnail;
                }
            }

            // Storage thumbnails already refreshed; ensure side thumbnails mapped and heading image updated
            this.setStorageThumbnails();
            const storageIdx = this.status.filters.findIndex(f => f.name === 'Storage alternative');
            if (storageIdx !== -1 && Array.isArray(this.storageIcons) && this.storageIcons.length) {
                const icon = this.storageIcons[this.status.extraStorage] || this.storageIcons[0];
                if (icon) this.status.filters[storageIdx].thumbnail = icon;
            }

            // Recompute price after mapping
            this.scheduleTotalAdjustment();
        },
        updateSize(size, filterIndex) {
            const sizeAsString = size.title.split(' | ')[1];
            this.status.currentSize = sizeAsString;
            this.status.filters[filterIndex].currentValue = sizeAsString;
            this.status.filters[filterIndex].thumbnail = size.featured_image?.src || size.featured_image || size.images?.[0];
            document.querySelector('.product-title-size').textContent = sizeAsString;

            this.changeProduct(size);
        },
        updateColor(color, filterIndex) {
            this.status.currentColor = color;
            this.status.filters[filterIndex].currentValue = color;
            this.status.filters[filterIndex].thumbnail = this.status.filters[filterIndex].availableColors.find(obj => obj.name === color).image;             
            // Rebuild Size options from configurator size_variants for this color
            this.rebuildSizesFromConfigurator();
            this.changeProduct();
        },
        rebuildSizesFromConfigurator() {
            const sizeIdx = this.status.filters.findIndex(f => f.name === 'Size');
            if (sizeIdx === -1) return;
            const wantGrande = this.status.extraStorage === 1;
            const color = this.status.currentColor;
            const products = Array.isArray(this.status.connectedProducts) ? this.status.connectedProducts : [];

            // helper to parse title segments
            const parse = (t) => {
                const parts = (t || '').split(' | ');
                return { base: (parts[0]||'').trim(), size: (parts[1]||'').trim(), color: (parts[2]||'').trim() };
            };

            // Find the connected product entry for this color and storage
            let baseEntry = products.find(p => {
                const title = p.title || '';
                const segs = parse(title);
                const storageOk = wantGrande ? title.includes('Grande') : !title.includes('Grande');
                return segs.color === color && storageOk;
            }) || products.find(p => parse(p.title||'').color === color);

            const sizeVariants = Array.isArray(baseEntry?.size_variants) ? baseEntry.size_variants : [];
            // Map to availableSizes entries
            const sizes = sizeVariants.map(sp => ({
                id: sp.id,
                title: sp.title,
                handle: sp.handle,
                featured_image: sp.featured_image,
                images: sp.images
            }));
            // Sort by numeric size if present
            const sizeFromTitle = (t) => (t || '').split(' | ')[1]?.trim() || '';
            const numericSize = (s) => parseInt((s||'').replace(/\D/g, ''), 10) || 0;
            sizes.sort((a,b) => {
                const sa = sizeFromTitle(a.title);
                const sb = sizeFromTitle(b.title);
                const na = numericSize(sa);
                const nb = numericSize(sb);
                if (na !== nb) return na - nb;
                return sa.localeCompare(sb);
            });

            this.status.filters[sizeIdx].availableSizes = sizes;
            if (sizes[0]) {
                this.status.filters[sizeIdx].thumbnail = sizes[0].featured_image?.src || sizes[0].featured_image || sizes[0].images?.[0] || this.status.filters[sizeIdx].thumbnail;
            }
        },
        scheduleTotalAdjustment() {
            // Debounce rapid successive updates to avoid excessive recalculations
            clearTimeout(this._totalAdjTimer);
            this._totalAdjTimer = setTimeout(() => {
                this.totalAdjustment();
            }, 50);
        },
        changeProduct(product){
            // Save current firmness settings before changing product
            const currentOption1 = this.status.option1;
            const currentOption2 = this.status.option2;
            
            // Choose connected product by exact title segments: base | size | color, and storage (Grande)
            const wantGrande = this.status.extraStorage === 1;
            const parse = (t) => {
                const parts = (t || '').split(' | ');
                return { base: (parts[0]||'').trim(), size: (parts[1]||'').trim(), color: (parts[2]||'').trim() };
            };
            const list = Array.isArray(this.status.connectedProducts) ? this.status.connectedProducts : [];
            let targetProduct = list
                .filter(p => wantGrande ? (p.title||'').includes('Grande') : !(p.title||'').includes('Grande'))
                .find(p => {
                    const segs = parse(p.title||'');
                    const sizeOk = this.status.currentSize ? (segs.size === this.status.currentSize) : true;
                    const colorOk = this.status.currentColor ? (segs.color === this.status.currentColor) : true;
                    return sizeOk && colorOk;
                });

            let targetTitle = document.title;

            // If a full product with handle was provided (e.g. from size_variants), use it directly
            if (product && product.handle) {
                targetProduct = product;
            } else if(!targetProduct && product) {
                // If a partial product was passed (e.g., from size_variants), resolve to full entry by id
                const byId = product.id ? list.find(p => p.id == product.id) : null;
                targetProduct = byId || product;
            }

            // Check if the desired object is found
            if (!targetProduct) {
                // Fallback: look into size_variants for a direct match (they include handle)
                const variantMatch = list
                    .filter(p => wantGrande ? (p.title||'').includes('Grande') : !(p.title||'').includes('Grande'))
                    .flatMap(p => Array.isArray(p.size_variants) ? p.size_variants : [])
                    .find(sp => {
                        const parts = (sp.title||'').split(' | ');
                        const size = (parts[1]||'').trim();
                        const colorSeg = (parts[2]||'').trim();
                        const sizeOk = this.status.currentSize ? (size === this.status.currentSize) : true;
                        const colorOk = this.status.currentColor ? (colorSeg === this.status.currentColor) : true;
                        return sizeOk && colorOk;
                    });
                if (variantMatch && variantMatch.handle) {
                    targetProduct = variantMatch;
                }
            }

            if (targetProduct && targetProduct.handle) {
                // Access the handle property of the desired object
                this.currentPage = targetProduct.handle;
                targetTitle = targetProduct.title;               

                //update size thumbnail
                //this.status.filters[0].thumbnail = targetProduct.featured_image;                
                this.status.productId = targetProduct.id;
                
                // Restore firmness settings after product change
                if (currentOption1) this.status.option1 = currentOption1;
                if (currentOption2) this.status.option2 = currentOption2;
                
                // Find and set the correct variant ID for the new product
                const baseProduct = list.find(p => p.id == this.status.productId);
                
                const targetVariant = baseProduct?.variants?.find(obj => {
                    // Check if the restored options match any variant of the new product
                    if(this.status.option1 && this.status.option2) {
                        return obj.option1.startsWith(this.status.option1) && obj.option2.startsWith(this.status.option2);
                    } else if(this.status.option1) {
                        return obj.option1.startsWith(this.status.option1);
                    }
                    return false;
                });
                
                if (targetVariant) {
                    this.status.currentVariant = targetVariant.id;
                } else if (baseProduct?.variants?.[0]?.id) {
                    // Fallback to the first variant if the specific firmness combination is not found
                    this.status.currentVariant = baseProduct.variants[0].id;
                } else {
                    // Final fallback: use the variant ID from the targetProduct itself if available
                    this.status.currentVariant = targetProduct.id; 
                }

                // Update the URL with the determined current variant ID
                this.currentPage = this.currentPage.split('?variant=')[0] + "?variant=" + this.status.currentVariant;

                // Update the firmness filter display if it exists
                const firmnessFilter = this.status.filters.find(f => f.name === 'Firmness');
                if (firmnessFilter) {
                    if (currentOption1 && currentOption2) {
                        firmnessFilter.currentValue = `${currentOption1}, ${currentOption2}`;
                    } else if (currentOption1) {
                        firmnessFilter.currentValue = currentOption1;
                    }
                }

            } else {
                console.log("Object not found");
            }

            // gift
            const giftOldValue = this.status.filters.find(item => item.name === "Gift");
            if(giftOldValue) {
                const matchingNewGift = document.querySelector(`[data-item="Gift"] [data-variant-name="${giftOldValue.currentValue}"]`)
                if(matchingNewGift){
                    matchingNewGift.click();
                }else{
                    this.selectedGift = 0;
                }
            }

            // offers 
            this.selectedOffers.forEach(offer => {
                const matchingNewOffer = document.querySelector(`[data-item="Offer"] [data-variant-name="${offer.name}"]`)
                if(matchingNewOffer){
                    matchingNewOffer.click();
                }else{
                    this.selectedOffers = [];
                }
            })

            // replace url
            const nextState = { additionalInformation: 'Product change' };
            // This will create a new entry in the browser's history, without reloading
            window.history.pushState(nextState, targetTitle, this.currentPage);
            // This will replace the current entry in the browser's history, without reloading
            window.history.replaceState(nextState, targetTitle, this.currentPage);
            document.title = targetTitle;
            
        },
        updatePageContents(targetUrl) {
            document.querySelector(".product__info-wrapper .product-form__btn").disabled = true;
            fetch(targetUrl)
            .then(function(response) {
                // When the page is loaded convert it to text
                return response.text()
            })
            .then((html) => {
                // Initialize the DOM parser
                let parser = new DOMParser();

                // Parse the text
                let fetchedPage = parser.parseFromString(html, "text/html");

                let scroll = window.scrollY;

                //disable scroll to prevent jumping
                window.addEventListener('scroll', function(event) {
                    event.preventDefault();
                });

                //gallery
                document.querySelector('.product-desktop-media').replaceWith(fetchedPage.querySelector('.product-desktop-media'));
                document.querySelector('.product-mobile-media').replaceWith(fetchedPage.querySelector('.product-mobile-media'));
                document.querySelector('product-modal').replaceWith(fetchedPage.querySelector('product-modal'));

                //product badges
                document.querySelector('.product-badges-wrapper').replaceWith(fetchedPage.querySelector('.product-badges-wrapper'));

                //price
                document.querySelector('.product-general-info-block.block-price').replaceWith(fetchedPage.querySelector('.product-general-info-block.block-price'));

                //breadcrumbs
                document.querySelector('product-breadcrumbs')?.replaceWith(fetchedPage.querySelector('product-breadcrumbs'));

                //title
                document.querySelector('.product-general-info-block h1')?.replaceWith(fetchedPage.querySelector('.product-general-info-block h1'));

                //variant picker
                document.querySelector('.product__content variant-picker')?.replaceWith(fetchedPage.querySelector('.product__content variant-picker'));

                //upsell block
                const upsellBlock = document.querySelector('.product-upsell-block');
                const newUpsellBlock = fetchedPage.querySelector('.product-upsell-block');
                if (upsellBlock && newUpsellBlock) {
                    upsellBlock.replaceWith(newUpsellBlock);
                } else if (upsellBlock) {
                    upsellBlock.innerHTML = "";
                }

                //product form
                document.querySelector('.product__info-wrapper product-form')?.replaceWith(fetchedPage.querySelector('.product__info-wrapper product-form'));

                const pickerAfterReplace = document.querySelector('.product__content variant-picker');
                if (pickerAfterReplace && pickerAfterReplace.dataset?.productId) {
                    this.status.productId = pickerAfterReplace.dataset.productId;
                }

                const productButton = document.querySelector('.product__info-wrapper product-form button[type="submit"]');

                if (productButton) {
                    if (productButton.hasAttribute('disabled')) productButton.removeAttribute('disabled');
                }

                //product quantity
                document.querySelector('.product-quantity__wrap')?.replaceWith(fetchedPage.querySelector('.product-quantity__wrap'));

                //product stock
                document.querySelector('.product-stock')?.replaceWith(fetchedPage.querySelector('.product-stock'));

                //replace all sections below
                const mainSectionFetched = fetchedPage.querySelector('.main-product-info');
                const mainSection = document.querySelector('.main-product-info');

                if (mainSection && mainSectionFetched) {
                    const parent = mainSection.parentNode;

                    // Define ignored selectors
                    const ignoredSelectors = ['#trustpilot-section'];

                    // Current DOM siblings after mainSection
                    const currentSiblings = Array.from(parent.children).slice(
                        Array.from(parent.children).indexOf(mainSection) + 1
                    );

                    // Fetched siblings after mainSectionFetched
                    const fetchedSiblings = Array.from(mainSectionFetched.parentNode.children).slice(
                        Array.from(mainSectionFetched.parentNode.children).indexOf(mainSectionFetched) + 1
                    );

                    // Filter fetched elements to skip ignored ones
                    const fetchedToInsert = fetchedSiblings.filter(
                        el => !ignoredSelectors.some(sel => el.matches(sel) || el.querySelector(sel))
                    );

                    let fetchIndex = 0;

                    currentSiblings.forEach(currentEl => {
                        const isIgnored = ignoredSelectors.some(sel => currentEl.matches(sel) || currentEl.querySelector(sel));

                        if (!isIgnored) {
                            const videosInEl = currentEl.querySelectorAll && currentEl.querySelectorAll('video');
                            if (videosInEl && videosInEl.length) {
                                videosInEl.forEach(v => {
                                    try { v.pause(); } catch (e) {}
                                    try { v.removeAttribute('src'); v.load(); } catch (e) {}
                                });
                            }
                            // Replace current element with fetched one if available
                            if (fetchIndex < fetchedToInsert.length) {
                                const clone = fetchedToInsert[fetchIndex].cloneNode(true);
                                parent.replaceChild(clone, currentEl);
                                fetchIndex++;
                            } else {
                                // No more fetched elements, remove extra
                                currentEl.remove();
                            }
                        }
                        // If ignored, do nothing; it stays in place
                    });

                    // Insert any remaining fetched elements after the last element
                    let last = mainSection;
                    while (last.nextElementSibling) last = last.nextElementSibling;
                    for (; fetchIndex < fetchedToInsert.length; fetchIndex++) {
                        last.insertAdjacentElement('afterend', fetchedToInsert[fetchIndex].cloneNode(true));
                        last = last.nextElementSibling;
                    }
                }

                //re-enable scroll and scroll to initial position
                window.removeEventListener('scroll', function(event) {
                    event.preventDefault();
                });
                window.scrollTo(0, scroll);
                setTimeout(() => {
                    let targetVariant = document.querySelector('[data-item="Side"] .filter-item__select--active');
                    if (targetVariant) {
                        targetVariant.click();
                    }
                }, 100);

                const scripts = fetchedPage.querySelectorAll('script');
                scripts.forEach((script) => {
                    if (script.textContent.includes('const configurator = {')) {
                        const scriptText = script.textContent;
                        // Extract core flags quickly
                        const giftLockedMatch = scriptText.match(/"giftLocked"\s*:\s*(true|false)/);
                        if (giftLockedMatch) {
                            this.status.giftLocked = giftLockedMatch[1] === 'true';
                        }

                        // Try to evaluate the configurator object from fetched page
                        try {
                            const patched = scriptText.replace('const configurator', 'window.__newConfigurator');
                            // eslint-disable-next-line no-new-func
                            new Function(patched)();
                            if (window.__newConfigurator) {
                                // minimally rehydrate dynamic data that can differ per size product
                                this.status.connectedProducts = window.__newConfigurator.connectedProducts || this.status.connectedProducts;
                                this.status.storage_alternative = window.__newConfigurator.storage_alternative || this.status.storage_alternative;
                                this.status.upsells = window.__newConfigurator.upsells || this.status.upsells;
                                this.status.baseProduct = window.__newConfigurator.baseProduct || this.status.baseProduct;
                                this.status.basePrice = window.__newConfigurator.basePrice || this.status.basePrice;
                                // Rebuild Size options for the current color/storage from size_variants
                                this.rebuildSizesFromConfigurator();
                                // Rebuild Firmness filter to reflect 1 vs 2 columns per size
                                if (Array.isArray(window.__newConfigurator.filters)) {

                                    const newFirmness = window.__newConfigurator.filters.find(f => f.name === 'Firmness');
                                    const currentFirmnessIndex = this.status.filters.findIndex(f => f.name === 'Firmness');

                                    if (newFirmness && currentFirmnessIndex !== -1) {
                                        console.log('Rebuilding firmness filter');
                                        // Save current firmness values before updating
                                        const currentFirmnessValue = this.status.filters[currentFirmnessIndex]?.currentValue || '';
                                        const currentOption1 = this.status.option1;
                                        const currentOption2 = this.status.option2;
                                        
                                        // Replace the filter entry entirely
                                        const firmnessData = this.status.filters[currentFirmnessIndex];
                                        firmnessData.options = newFirmness.options;
                                        firmnessData.thumbnail = newFirmness.thumbnail;
                                        
                                        // Keep the current firmness value if it exists
                                        if (currentFirmnessValue) {
                                            firmnessData.currentValue = currentFirmnessValue;
                                            
                                            // Update option1 and option2 from the current value
                                            const cv = currentFirmnessValue.split(',').map(s => s.trim()).filter(Boolean);
                                            this.status.option1 = cv[0];
                                            this.status.option2 = cv[1];
                                        } else {
                                            // Fallback to the new firmness value if no current value exists
                                            if (firmnessData.currentValue.includes(',') && !newFirmness.currentValue.includes(',')) {
                                                firmnessData.currentValue = firmnessData.currentValue.split(',')[0];
                                            } else if (!firmnessData.currentValue.includes(',') && newFirmness.currentValue.includes(',')) {
                                                const lastPartOfNewFirmness = newFirmness.currentValue.split(',')[1];
                                                firmnessData.currentValue = firmnessData.currentValue + ', ' + lastPartOfNewFirmness;
                                            }
                                            
                                            // Sync option1/option2 from currentValue if present
                                            const cv = (newFirmness.currentValue || '').split(',').map(s => s.trim()).filter(Boolean);
                                            this.status.option1 = cv[0] || undefined;
                                            this.status.option2 = cv[1] || undefined;
                                        }
                                        
                                        // If no prior values, default to first available(s)
                                        const opts = Array.isArray(newFirmness.options) ? newFirmness.options : [];
                                        if (!this.status.option1 && opts[0]?.values?.length) {
                                            this.status.option1 = opts[0].values[0]?.value || opts[0].values[0];
                                        }
                                        if (opts.length > 1 && !this.status.option2 && opts[1]?.values?.length) {
                                            this.status.option2 = opts[1].values[0]?.value || opts[1].values[0];
                                        } else if (opts.length === 1) {
                                            this.status.option2 = undefined;
                                        }
                                        
                                        // Update display currentValue based on the options we've set
                                        const parts = [this.status.option1, this.status.option2].filter(Boolean);
                                        this.status.filters[currentFirmnessIndex].currentValue = parts.join(', ');
                                    }
                                }
                                // keep currentSize/currentColor as selected by user
                                delete window.__newConfigurator;
                                
                                this.selectMatchingVariant();
                            }
                        } catch (e) {
                            console.warn('Failed to rehydrate configurator from fetched page: ', e);
                        }
                    }
                });

                this.toggleOfferVisibility();
                this.toggleGiftVisibility();
                this.setStorageThumbnails();
                this.selectFirstTopMattressForCurrentProduct();
                this.selectFirstOptionalTopMattressForCurrentProduct();

                // Remap selections to current product data so visuals update with color/size
                this.remapSelectionsToCurrentProduct();
            })
            .catch(function(err) {  
                console.log('Failed to fetch page: ', err);  
            });
            if (this.sideFilterIndex != '-1') {
                const productObj = this.status.connectedProducts.find(obj => obj.id == this.status.productId);
                productObj?.variants?.forEach((variant, index) => {
                    if (this.status.filters[this.sideFilterIndex]?.options?.[0]?.values?.[index]?.media_id) {
                        this.status.filters[this.sideFilterIndex].options[0].values[index].media_id = variant.featured_media?.id;
                    }
                });
            }
        },
        
        updateVariant(event) {

            let parentColumn = event.target.parentNode;
            let target = event.target;
            let filterIndex = target.dataset.filterIndex;

            //update variables
            this.status[target.dataset.optionId] = target.dataset.value;

            //change current variant
            const foundProduct = this.status.connectedProducts && this.status.connectedProducts.length
                ? this.status.connectedProducts.find(obj => obj.id == this.status.productId)
                : null;
            const currentProduct = foundProduct || this.status.baseProduct;
            if (!currentProduct || !currentProduct.variants) return;
            const currentVariant = currentProduct.variants.find(obj => {
                if(this.status.option1 && this.status.option2 && this.status.option3){
                    return obj.option1.startsWith(this.status.option1) && obj.option2.startsWith(this.status.option2) && obj.option3.startsWith(this.status.option3);
                } else if(this.status.option1 && this.status.option2) {
                    return obj.option1.startsWith(this.status.option1) && obj.option2.startsWith(this.status.option2);
                } else {
                    return obj.option1.startsWith(this.status.option1);
                }
            });
            if (!currentVariant) return;
            this.status.currentVariant = currentVariant.id;

            //close other filters
            parentColumn.querySelectorAll('.filter-item__select').forEach( item => {
                if (item != target) {
                    item.classList.remove('filter-item__select--active');
                }
            });

            // toggle clicked filter
            target.classList.add('filter-item__select--active');
            event.stopPropagation();

            this.currentPage = this.currentPage.split('?variant=')[0];
            this.currentPage = this.currentPage + "?variant=" + this.status.currentVariant;

            event.preventDefault();
            // replace url
            const nextState = { additionalInformation: 'Variant change' };
            // This will create a new entry in the browser's history, without reloading
            window.history.pushState(nextState, document.title, this.currentPage);
            // This will replace the current entry in the browser's history, without reloading
            window.history.replaceState(nextState, document.title, this.currentPage);


            //if double firmness
            if(this.status.option1 && this.status.option2) {
                this.status.filters[filterIndex].currentValue = this.status.option1 + ", " + this.status.option2;
            } else if (this.status.option1) {
                this.status.filters[filterIndex].currentValue = this.status.option1;
            }
            

        },
        updateSide(value, variantId, filterIndex, index) {

            if (value == undefined || variantId == undefined || filterIndex == undefined || index == undefined) return;

            this.status.filters[filterIndex].currentValue = value;
            this.status.filters[filterIndex].thumbnail = this.status.filters[filterIndex].options[0].values[index].image;
            this.selectedSide = variantId;
            const variantSizes = document.querySelectorAll('[option-picker-name="' + this.status.filters[filterIndex].options[0].optionName + '"] label');
            variantSizes[index]?.click();

            this.selectedVariantImg = this.status.filters[filterIndex].options[0].values[index].media_id;

            // find all media items in gallery
            let images = document.querySelectorAll('.product-desktop-media .product-media-grid__item');

            // find the image attached to specific variant
            let target = Array.from(images).find(img => img.dataset.mediaId == this.selectedVariantImg);

            // make selected variant image main in gallery
            if (target) {
                let container = target.parentNode;
                container.insertBefore(target, container.firstChild);
            }

        },
        updateMainMattressFirmness(event) {

            let parentColumn = event.target.parentNode;
            let target = event.target;
            let filterIndex = target.dataset.filterIndex;

            //update variables
            this.selectedOptionalMainmattressOptionsPicked[target.dataset.optionId] = target.dataset.value;

            this.status.filters[filterIndex].currentValue = this.status.filters[filterIndex].currentValue = `${this.selectedOptionalMainmattressOptionsPicked.option1}${this.selectedOptionalMainmattressOptionsPicked.option2 ? `, ${this.selectedOptionalMainmattressOptionsPicked.option2}` : ''}`;
            
            let currentProdId = this.status.productId;
            let selectedMattress = this.status.upsells.find(upsell => upsell.productId == currentProdId).optional_mainmattresses.find(mattress => mattress.id == this.selectedOptionalMainmattress);

            

            let selectedVariant = selectedMattress.variants[0].find(variant => (variant.option1 == this.selectedOptionalMainmattressOptionsPicked.option1 && variant.option2 == this.selectedOptionalMainmattressOptionsPicked.option2) );
            this.selectedOptionalMainmattressVariant = selectedVariant.id;
            this.selectedOptionalMainmattressVariantPrice = selectedVariant.price;

            //close other filters
            parentColumn.querySelectorAll('.filter-item__select').forEach( item => {
                if (item != target) {
                    item.classList.remove('filter-item__select--active');
                }
            });

            // toggle clicked filter
            target.classList.add('filter-item__select--active');

            this.scheduleTotalAdjustment();
            event.stopPropagation();

        },
        multiselectToggleSheets(event) {            
            // this is used only for sheets

            let target = event.target;
            let variantId = target.dataset.variantId;
            let variantName = target.dataset.variantName;

            const index = this.status.filters.findIndex(item => item.name == "Sheets");

            if (!variantId) {

                //close other filters
                document.querySelectorAll('[data-item="Sheets"] .filter-item__select').forEach( item => {
                    if (item != target) {
                        item.classList.remove('filter-item__select--active');
                    } else {
                        item.classList.add('filter-item__select--active');
                    }
                });
                //remove sheets from upsell
                this.selectedSheets = [];
                this.selectedSheets.push({
                    id: variantId,
                    name: variantName
                });
                this.status.filters[index].currentValue = variantName;

            } else {

                //remove default
                this.selectedSheets = this.selectedSheets.filter(item => item.id != "");

                if (!this.selectedSheets.find(sheet => sheet.id == variantId)) {

                    //if item not in cart  in cart
                    this.selectedSheets.push({
                        quantity: Number(target.nextSibling.dataset.quantity),
                        id: Number(variantId),
                        name: variantName
                    });
                    
                } else {
                    //remove item if deselected
                    this.selectedSheets = this.selectedSheets.filter(item => item.id !== Number(variantId));
                }                

                //toggle items in subcart
                target.classList.toggle('filter-item__select--active');

                if(!document.querySelectorAll('[data-item="Sheets"] .filter-item__select--active').length) {
                    //reset selection if no regular selected
                    document.querySelector('[data-item="Sheets"] [data-variant-id=""]').click();
                } else {
                    document.querySelector('[data-item="Sheets"] [data-variant-id=""]').classList.remove('filter-item__select--active');
                }
            }  
            // change list of selected colors
            this.status.filters[index].currentValue = this.selectedSheets.map(item => item.name).toString();
        },
        itemQuantityUpdateSheets(data) {
            let id = data.id;
            this.selectedSheets.forEach( item => {
                if(item.id == id) {
                    item.quantity = data.quantity;
                }
            });
        },
        multiselectToggleOffers(event) {            
            // this is used only for Offers

            let target = event.target;
            let variantId = target.dataset.variantId;
            let variantName = target.dataset.variantName;

            const index = this.status.filters.findIndex(item => item.name == "Offers");

            if (!variantId) {

                //close other filters
                document.querySelectorAll('[data-item="Offers"] .filter-item__select').forEach( item => {
                    if (item != target) {
                        item.classList.remove('filter-item__select--active');
                    } else {
                        item.classList.add('filter-item__select--active');
                    }
                });
                //remove Offers from upsell
                this.selectedOffers = [];
                this.selectedOffers.push({
                    id: variantId,
                    name: variantName
                });
                this.status.filters[index].currentValue = variantName;

            } else {

                //remove default
                this.selectedOffers = this.selectedOffers.filter(item => item.id != "");

                if (!this.selectedOffers.find(offer => offer.id == variantId)) {

                    //if item not in cart  in cart
                    this.selectedOffers.push({
                        quantity: Number(target.nextSibling.dataset.quantity),
                        id: Number(variantId),
                        name: variantName
                    });
                    
                } else {
                    //remove item if deselected
                    this.selectedOffers = this.selectedOffers.filter(item => item.id !== Number(variantId));
                };               

                //toggle items in subcart
                target.classList.toggle('filter-item__select--active');
                if(!document.querySelectorAll('[data-item="Offer"] .filter-item__select--active').length) {
                    //reset selection if no regular selected
                    document.querySelector('[data-item="Offer"] [data-variant-id=""]').click();
                } else {
                    document.querySelector('[data-item="Offer"] [data-variant-id=""]').classList.remove('filter-item__select--active');
                }
            }  
            // change list of selected colors
            this.status.filters[index].currentValue = this.selectedOffers.map(item => item.name).toString();
        },
        itemQuantityUpdateOffers(data) {
            let id = data.id;
            this.selectedOffers.forEach( item => {
                if(item.id == id) {
                    item.quantity = data.quantity;
                }
            });
        },
        selectFirstTopMattressForCurrentProduct() {
            const upsell = this.status.upsells.find(u => u.productId == this.status.productId);
            const topFilterIndex = this.status.filters.findIndex(i => i.name === 'Mattresses');
            if (!upsell || topFilterIndex === -1) return;
            const first = (upsell.topmattresses || [])[0];
            if (first) {
                this.selectedTopmattress = first.id || 0;
                this.status.filters[topFilterIndex].currentValue = first.description ? `${first.name} (${first.description})` : first.name;
                this.status.filters[topFilterIndex].thumbnail = first.thumbnail || this.status.filters[topFilterIndex].thumbnail;
            }
        },
        selectFirstOptionalTopMattressForCurrentProduct() {
            const upsell = this.status.upsells.find(u => u.productId == this.status.productId);
            const optFilterIndex = this.status.filters.findIndex(i => i.name === 'Optional top mattresses');
            if (!upsell || optFilterIndex === -1) return;
            const first = (upsell.optional_topmattresses || [])[0];
            if (first) {
                this.selectedOptionalTopmattress = first.id || 0;
                this.status.filters[optFilterIndex].currentValue = first.description ? `${first.name} (${first.description})` : first.name;
                this.status.filters[optFilterIndex].thumbnail = first.thumbnail || this.status.filters[optFilterIndex].thumbnail;
            } else {
                this.selectedOptionalTopmattress = 0;
            }
        },
        updateHeadboard(id, name, thumbnail, previewImage, index) {
            this.selectedHeadboard = id;
            this.status.filters[index].currentValue = name;
            this.status.filters[index].thumbnail = thumbnail;
            this.selectedHeadboardPreview = previewImage;

            if (!this.status.giftLocked) return;

            const giftHeading = document.querySelector('[data-item="Gift"] .filter-item__heading');
            const headboardHeading = document.querySelector('[data-item="Headboards"] .filter-item__heading');

            // Determine if an item is selected.
            const isGiftSelected = !!this.selectedGift;
            const isHeadboardSelected = !!this.selectedHeadboard;

            // The 'Gift' option should be disabled ONLY if a headboard is selected.
            giftHeading?.classList.toggle('filter-item__heading--disabled', isHeadboardSelected && !isGiftSelected);

            // The 'Headboards' option should be disabled if a gift is selected.
            headboardHeading?.classList.toggle('filter-item__heading--disabled', isGiftSelected);
        },
        updateLegs(id, name, thumbnail, previewImage, height, index) {
            this.selectedLegs = id;
            this.status.filters[index].currentValue = `${name} (${height})`;
            this.status.filters[index].thumbnail = thumbnail;
            this.selectedLegsPreview = previewImage;
        },
        updateGift(id, name, thumbnail, previewImage, size, index) {
            this.selectedGift = id;
            this.status.filters[index].currentValue = `${name}`;
            this.status.filters[index].thumbnail = thumbnail;
        },
        updateTopmattress(id, name, description, thumbnail, index) {
            this.selectedTopmattress = id;
            this.status.filters[index].currentValue = `${name} (${description})`;
            this.status.filters[index].thumbnail = thumbnail;
        },
        updateOptionalTopmattress(id, name, description, thumbnail, index) {
            this.selectedOptionalTopmattress = id;
            this.status.filters[index].currentValue = `${name} ${description ? `(${description})` : ''}`;
            this.status.filters[index].thumbnail = thumbnail;
        },
        updateOptionalPuf(id, name, description, thumbnail, index) {
            this.selectedOptionalPuf = id;
            this.status.filters[index].currentValue = `${name} ${description ? `(${description})` : ''}`;
            this.status.filters[index].thumbnail = thumbnail;
        },
        updateOptionalMainmattress(id, name, description, thumbnail, index) {
            this.selectedOptionalMainmattress = id;
            this.status.filters[index].currentValue = `${name} ${description ? `(${description})` : ''}`;
            this.status.filters[index+1].currentValue = ""
            this.status.filters[index].thumbnail = thumbnail;

            //reset fimrness options
            this.selectedOptionalMainmattressSelected = [];

            //populate firmness options
            if(this.selectedOptionalMainmattress) {
                let currentId = this.status.productId;
                let currentProd = this.status.upsells.find(upsell => upsell.productId == currentId);

                let optionsToBuild = currentProd.optional_mainmattresses.find(mainMattress => mainMattress.id == this.selectedOptionalMainmattress).options[0];
                this.selectedOptionalMainmattressOptions = optionsToBuild;

                this.selectedOptionalMainmattressOptionsPicked.option1 = this.selectedOptionalMainmattressOptions[0]?.values[0];
                this.selectedOptionalMainmattressOptionsPicked.option2 = this.selectedOptionalMainmattressOptions[1]?.values[0];

                this.status.filters[index+1].currentValue = `${this.selectedOptionalMainmattressOptionsPicked.option1}${this.selectedOptionalMainmattressOptionsPicked.option2 ? `, ${this.selectedOptionalMainmattressOptionsPicked.option2}` : ''}`;

                let initialIncrement = currentProd.optional_mainmattresses.find(mainMattress => mainMattress.id == this.selectedOptionalMainmattress).rawPrice;

                this.selectedOptionalMainmattressVariantPrice = Number(initialIncrement);
                this.totalAdjustment();
            }
            
            

        },
        async buildPayload(inputQuantity) {

            //reset extra items
            this.extraCart = [];

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedHeadboard
            });
            

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedLegs
            });

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedOptionalMainmattressVariant
            });

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedTopmattress
            });

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedOptionalTopmattress
            });

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedOptionalPuf
            });

            this.extraCart.push({
                'quantity': Number(inputQuantity),
                'id': this.selectedGift
            });
            
            this.selectedSheets.forEach( sheet => {
                this.extraCart.push({
                    'quantity': sheet.quantity * Number(inputQuantity),
                    'id': sheet.id
                });
            });

            this.selectedOffers.forEach( offer => {
                this.extraCart.push({
                    'quantity': offer.quantity * Number(inputQuantity),
                    'id': offer.id
                });
            });

            //clear from empty items and push to global scope so it is accessible by default add to form function
            window.Shopify.upsells = this.extraCart.filter(item => item.id !== 0 && item.id !== "");

        },

        totalAdjustment() {
            let currentId = this.status.productId;
            let currentUpsells = this.status.upsells.filter(upsell => upsell.productId == currentId);
            currentUpsells = Object.assign({}, currentUpsells);
            currentUpsells = currentUpsells[0];
            if (!currentUpsells) {
                return;
            }

            let basePrice = Number(this.status.basePrice);
            let priceIncrement = 0;

            //main mattress
            let selectedMainattressId = this.selectedOptionalMainmattress;
            if(selectedMainattressId && currentUpsells?.optional_mainmattresses) {
                let selectedMattress = currentUpsells.optional_mainmattresses.filter(mattress => mattress.id == selectedMainattressId);           
                priceIncrement = priceIncrement + Number(this.selectedOptionalMainmattressVariantPrice || 0);
            }

            //top mattress
            let selectedMattressId = this.selectedTopmattress;
            if(selectedMattressId && currentUpsells?.topmattresses) {
                let selectedMattress = currentUpsells.topmattresses.filter(mattress => mattress.id == selectedMattressId);
                if(selectedMattress[0]?.rawPrice) {
                    priceIncrement = priceIncrement + Number(selectedMattress[0].rawPrice);
                }
            }

            //optional top mattress
            let selectedOptionalMattressId = this.selectedOptionalTopmattress;
            if(selectedOptionalMattressId && currentUpsells?.optional_topmattresses) {
                let selectedMattress = currentUpsells.optional_topmattresses.filter(mattress => mattress.id == selectedOptionalMattressId);
                if(selectedMattress[0]?.rawPrice) {
                    priceIncrement = priceIncrement + Number(selectedMattress[0].rawPrice);
                }
            }

            //optional top mattress
            let selectedOptionaPufId = this.selectedOptionalPuf;
            if(selectedOptionaPufId && currentUpsells?.optional_puf) {
                let selectedPuf = currentUpsells.optional_puf.filter(puf => puf.id == selectedOptionaPufId);
                if(selectedPuf[0]?.rawPrice) {
                    priceIncrement = priceIncrement + Number(selectedPuf[0].rawPrice);
                }
            }
            
            //headboard
            let selectedHeadboardId = this.selectedHeadboard;
            const headboardOldValue = this.status.filters.find(item => item.name === "Headboards");
            if(selectedHeadboardId != 0 && currentUpsells?.headboards && headboardOldValue) {
                let selectedHeadboard = currentUpsells.headboards.filter(headboard => headboard.name == headboardOldValue.currentValue);
                if(selectedHeadboard[0]?.rawPrice) {
                    priceIncrement = priceIncrement + Number(selectedHeadboard[0].rawPrice);
                }
            }

            // gift (no DOM side-effects)
            const giftOldValue = this.status.filters.find(item => item.name === "Gift");

            //legs
            let selectedLegsId = this.selectedLegs;
            if(selectedLegsId && currentUpsells?.legs) {
                let selectedLegs = currentUpsells.legs.filter(leg => leg.id == selectedLegsId);
                if(selectedLegs[0]?.rawPrice) {
                    priceIncrement = priceIncrement + Number(selectedLegs[0].rawPrice);
                }
            }

            //sheets
            let selectedSheetsArray = this.selectedSheets || [];

            selectedSheetsArray.forEach(function(selectedSheet){
                let quantity = selectedSheet.quantity;
                let selectedSheetId = selectedSheet.id;
                if(selectedSheetId && currentUpsells?.sheets) {
                    let selectedSheets = currentUpsells.sheets.filter(sheet => sheet.id == selectedSheetId);
                    if(selectedSheets[0]?.rawPrice !== undefined) {
                        priceIncrement = priceIncrement + (quantity * Number(selectedSheets[0].rawPrice));
                    }
                }

            });

            //offers
            let selectedOffersArray = this.selectedOffers || [];

            selectedOffersArray.forEach(function(selectedOffer){
                let quantity = selectedOffer.quantity;
                let selectedOfferId = selectedOffer.id;
                if(selectedOfferId && currentUpsells?.offers) {
                    let selectedOffers = currentUpsells.offers.filter(offer => offer.id == selectedOfferId);
                    if(selectedOffers[0]){
                        if(selectedOffers[0].rawPrice !== undefined) {
                            priceIncrement = priceIncrement + (quantity * Number(selectedOffers[0].rawPrice));
                        }
                    }
                }

            });

            //calculation
            let newPrice = basePrice + priceIncrement;
            newPrice = (newPrice/100.0).toFixed(2);
            var parts   = newPrice.split('.'),
            integers = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + "."),
            decimals   = parts[1] ? ("," + parts[1]) : '';
            if (decimals == ",00") {
                decimals = "";
            }


            document.querySelectorAll('.product-price__current-price').forEach(function(element){
                element.innerHTML = integers + decimals + " kr";
            });
        },

        toggleOfferVisibility() {
            const offerBlock = document.querySelector('.configurator-wrapper__filter [data-item="Offer"]')
            if(offerBlock){
                if(offerBlock.querySelector('.filter-item__content .filter-item__select-card-wrapper')){
                    offerBlock.classList.add('show-block-product-specific')
                } else {
                    offerBlock.classList.remove('show-block-product-specific');                  
                }
            }
        },
        
        toggleGiftVisibility() {
            const giftBlock = document.querySelector('.configurator-wrapper__filter [data-item="Gift"]')
            if(giftBlock){
                if(giftBlock.querySelector('.filter-item__content .filter-item__select')){
                    giftBlock.classList.add('show-block-product-specific')
                } else {
                    giftBlock.classList.remove('show-block-product-specific');                  
                }
            }
        },
        updateStorage(index, filterIndex) {
            if (index == null || filterIndex == null) return;
            
            this.status.extraStorage = index;
            this.status.filters[filterIndex].currentValue = this.status.filters[filterIndex].availableStorage[index];
            this.changeProduct();
            this.setStorageThumbnails();
            this.status.filters[filterIndex].thumbnail = this.storageIcons[index];
            // Storage affects available sizes for a color; rebuild size options
            this.rebuildSizesFromConfigurator();
        },
        setStorageThumbnails() {
            if (this.status.storage_alternative) {
                this.storageIcons = [];
                const product = this.status.connectedProducts?.find(p => p.id == this.status.productId) || this.status.baseProduct;
                const altRecord = this.status.storage_alternative.find(p => p.productId == this.status.productId);
                if (!product || !altRecord) return;
                const alternativeEntry = altRecord.storage_alternative;

                if (product?.featured_image) this.storageIcons.push(product.featured_image);
                if (alternativeEntry?.featured_image) this.storageIcons.push(alternativeEntry.featured_image);

                if (product?.title?.includes("Grande")) {
                    this.storageIcons.reverse();
                }
            }
            
        }

    },

    watch: {
        currentPage: {
            handler(val) {
                this.status.currentPage = val;
                this.updatePageContents(val);
                this.setStorageThumbnails();
                if(document.querySelector('.product__content variant-picker')) {
                    this.status.productId = document.querySelector('.product__content variant-picker').dataset.productId;
                }
                
            },
            immediate: true
        },

        status: {
            handler(val) {
                // Run on changes, but debounce to batch updates
                this.scheduleTotalAdjustment();
            },
            deep: true
        },
        selectedSheets: {
            handler(val) {
                this.scheduleTotalAdjustment();
            },
            deep: true
        },
        selectedOffers: {
            handler(val) {
                this.scheduleTotalAdjustment();
            },
            deep: true
        }
    }
}
</script>